export default __webpack_public_path__ + "static/media/Access to all Schengen.2032d4a6.svg";